const SRS_TO_GTS_SORT_MAPPING = {
    default: 'DEFAULT_SORT',
    '-averageRating': 'RATING_DESC',
    '-bedrooms': 'BEDROOMS_DESC',
    bedrooms: 'BEDROOMS_ASC',
    '-prices': 'PRICE_DESC',
    prices: 'PRICE_ASC',
    '-travelerReviewCount': 'NUM_REVIEWS_DESC'
};

const REDUX_TO_SEARCH_PARAMS_MAPPING_SCHEMA = {
    adultsCount: 'coreFilters.adults',
    arrival: 'dates.arrivalDate',
    ascending: null,
    childrenCount: 'coreFilters.children',
    currency: null,
    departure: 'dates.departureDate',
    filter: 'filters',
    include: null,
    locale: null,
    maxBathrooms: 'coreFilters.maxBathrooms',
    maxBedrooms: 'coreFilters.maxBedrooms',
    maxNightlyPrice: 'coreFilters.maxNightlyPrice',
    maxTotalPrice: 'coreFilters.maxTotalPrice',
    minBathrooms: 'coreFilters.minBathrooms',
    minBedrooms: 'coreFilters.minBedrooms',
    minNightlyPrice: 'coreFilters.minNightlyPrice',
    minTotalPrice: 'coreFilters.minTotalPrice',
    neLat: 'boundingBox.maxLat',
    neLong: 'boundingBox.maxLng',
    orderBy: [
        'sort',
        (value, source) => {
            const prefix = source.ascending ? '' : '-';
            return (
                SRS_TO_GTS_SORT_MAPPING[`${prefix}${value}`] ||
                SRS_TO_GTS_SORT_MAPPING.default
            );
        }
    ],
    page: 'paging.page',
    pageSize: 'paging.pageSize',
    petIncluded: ['coreFilters.pets', (value) => (value ? 1 : 0)],
    q: 'q',
    regionId: ['region', (value) => `${value}`],
    site: null,
    swLat: 'boundingBox.minLat',
    swLong: 'boundingBox.minLng',
    zoom: null,
    searchTermUuid: 'lbsUuid',
    searchbucket: null,
    pinnedPropertyListing: ['pinnedPropertyListing', (value) => `${value}`],
    isSameDaySelected: 'dates.isSameDaySelected',
    filterVersion: ['filterVersion', (value) => `${value}`]
};
const DEFAULT_PARAMS = {
    paging: {page: 1, pageSize: 50}
};
const transformObjBySchema = (source, schema) => {
    return Object.keys(source).reduce((target, key) => {
        const fieldOptions = schema[key];

        if (fieldOptions) {
            const [path, transformValue] = [].concat(fieldOptions);
            const sourceValue = source[key];
            const targetValue = transformValue
                ? transformValue(sourceValue, source, key)
                : sourceValue;
            const pathParts = path.split('.');

            return {
                ...target,
                ...pathParts.reduceRight((result, part, index, array) => {
                    if (index === array.length - 1) {
                        return {
                            [part]: targetValue
                        };
                    }
                    return {
                        [part]: {
                            ...target[part],
                            ...result
                        }
                    };
                }, {})
            };
        }

        return target;
    }, DEFAULT_PARAMS);
};

module.exports = (reduxParams) =>
    transformObjBySchema(reduxParams, REDUX_TO_SEARCH_PARAMS_MAPPING_SCHEMA);
